import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import AssignmentIcon from "@material-ui/icons/Assignment";
import RepeatIcon from "@material-ui/icons/Repeat";

import RecurringTasks from "../recurring_tasks/List/List";
import { CreateRecurringTask } from "./Create/Create";
import { EditRecurringTask } from "./Edit/Edit";

const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 12,
		padding: "1px",
	},
}))(Badge);

const Icon = () => (
	<StyledBadge color="secondary" badgeContent={<RepeatIcon fontSize="small" />}>
		<AssignmentIcon />
	</StyledBadge>
);
export const recurringTaskResource = {
	list: RecurringTasks,
	create: CreateRecurringTask,
	edit: EditRecurringTask,
	icon: Icon,
};
